import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Typography
} from "@mui/material";
import HttpService from "../../src/services/httpService";

const iconOptions = [
  { label: "Facebook", value: "fa fa-facebook" },
  { label: "Instagram", value: "fa fa-instagram" },
  { label: "Twitter", value: "fa fa-twitter" },
  { label: "LinkedIn", value: "fa fa-linkedin" },
  { label: "YouTube", value: "fa fa-youtube" },
  { label: "Pinterest", value: "fa fa-pinterest" }
];

export default function SocialMediaManager() {
  const [entries, setEntries] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    iconCode: "",
    socialUrl: "",
    imageUrl: "",
  });
  const [open, setOpen] = useState(false);
  const [editId, setEditId] = useState(null);
  const [deleteModelIsOpen,setDeleteModelIsOpen] = useState()
  const [deleteId, setDeleteId] = useState("")

  useEffect(() => {
    loadEntries();
  }, []);

  const loadEntries = async () => {
    const res = await HttpService.socialMediaWebQuotationGet();
    setEntries(res.data);
  };

  const handleSubmit = async () => {
    if (editId) {
      await HttpService.socialMediaWebQuotationPut(editId, formData);
    } else {
      await HttpService.socialMediaWebQuotationPost(formData);
    }
    await loadEntries();
    handleClose();
  };

  const handleDelete = async (id) => {
    await HttpService.socialMediaWebQuotationDelete(id);
    await loadEntries();
  };

  const handleClose = () => {
    setOpen(false);
    setFormData({
      name: "",
      iconCode: "",
      socialUrl: "",
      imageUrl: "",
    });
    setEditId(null);
  };

  const handleEdit = (entry) => {
    setFormData(entry);
    setEditId(entry._id);
    setOpen(true);
  };

  
  return (
    <Box p={3}>
      <Button variant="contained" onClick={() => setOpen(true)}>
        Add Social Link
      </Button>
      <Table sx={{ mt: 2 }}>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Icon</TableCell>
            <TableCell>URL</TableCell>
            {/* <TableCell>Image</TableCell> */}
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {entries.length>0 && entries?.map((entry) => (
            <TableRow key={entry?._id}>
              <TableCell>{entry?.name}</TableCell>
              <TableCell>
                <i
                  className={`${entry?.iconCode} fa-2x`}
                  style={{ marginRight: 8 }}
                ></i>
                {/* {entry.iconCode} */}
              </TableCell>

              <TableCell>
                <a
                  href={entry.socialUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {entry.socialUrl}
                </a>
              </TableCell>
              {/* <TableCell>
                <img src={entry.imageUrl} alt="icon" width={40} />
              </TableCell> */}
              <TableCell> 
                <Button onClick={() => handleEdit(entry)}>Edit</Button>
                <Button color="error"
                  onClick={() => {
                    setDeleteId(entry?._id)
                    setDeleteModelIsOpen(true);
                  }}
                  >
                  Delete
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {/* Form Dialog */}
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>{editId ? "Edit" : "Add"} Social Media</DialogTitle>
        <DialogContent>
          <TextField
            label="Name"
            fullWidth
            margin="dense"
            value={formData?.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          />
          <FormControl fullWidth margin="dense">
            <InputLabel>Icon</InputLabel>
            <Select
              value={formData?.iconCode}
              label="Icon"
              onChange={(e) =>
                setFormData({ ...formData, iconCode: e.target.value })
              }
            >
              {iconOptions?.map((option) => (
                <MenuItem key={option?.value} value={option?.value}>
                  <i className={option?.value} style={{ marginRight: 8 }}></i>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            label="Social URL"
            fullWidth
            margin="dense"
            value={formData.socialUrl}
            onChange={(e) =>
              setFormData({ ...formData, socialUrl: e.target.value })
            }
          />
          {/* <TextField
            label="Image URL"
            fullWidth
            margin="dense"
            value={formData.imageUrl}
            onChange={(e) => setFormData({ ...formData, imageUrl: e.target.value })}
          /> */}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button variant="contained" onClick={handleSubmit}>
            {editId ? "Update" : "Create"}
          </Button>
        </DialogActions>  
      </Dialog>


    {/* Delete MOdel */}

      <Dialog
        open={deleteModelIsOpen}
        onClose={() => {
          setDeleteModelIsOpen(false);
        }}
        maxWidth="lg" // Adjust maxWidth ('xs', 'sm', 'md', 'lg', 'xl' for default sizes)
        PaperProps={{
          style: {
            width: "25%", // Set custom width
            maxHeight: "50vh", // Optionally limit height
          },
        }}
      >
        <DialogContent>
          <Typography variant="h6">
            {" "}
            Are you sure you want to delete it?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            style={
              {
                //   backgroundColor: "red",
              }
            }
            variant="contained"
            color="primary"
            onClick={() => {
              handleDelete(deleteId)
              setDeleteModelIsOpen(false)
            }}
          >
            Yes
          </Button>
          <Button
            onClick={() => {
              setDeleteModelIsOpen(false);
            }}
            variant="contained"
            color="secondary"
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
